import { h } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Icon from '../../Global/Icon';
import Text from '../../Global/Text';
import { replaceAll } from '../../../utilities/common';

const Link = ({
  label,
  link,
  icon,
  target,
  className,
  tracking,
  columns,
  dataTealium,
  translations,
}) => (
  <div className={`form__field--${columns}col`}>
    <a
      href={replaceAll(link, translations, {})}
      target={target}
      className={`${className} ${tracking}`}
      data-tealium={dataTealium}
    >
      {icon &&
      <Icon icon={icon}/>
      }
      <Text value={label}/>
    </a>
  </div>
);

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          translations,
        },
      },
    } = state;
    return {
      translations,
    };
  })
)(Link);

Link.defaultProps = {
  icon: null,
  target: '_blank',
  className: '',
  tracking: 'tealiumLink',
  columns: '12',
  dataTealium: null,
};

Link.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  tracking: PropTypes.string,
  columns: PropTypes.string,
  dataTealium: PropTypes.string,
  translations: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/Link.jsx